import {createAsyncThunk} from '@reduxjs/toolkit'

import {changeLocation, systemAlert} from '@web/actions/application'
import {isMobile} from '@web/helpers/userAgent'
import {commonSelector} from '@web/slices/common/slice'
import {orderSheetCouponSelector} from '@web/slices/orderSheetCoupon/slice'

import api from './apis'
import {RejectValue} from './constants'
import {
    ThunkApi,
    ChangeUseAllCouponParams,
    ChangeUseAllCouponPayload,
    FetchUseAllCouponParams,
    FetchUseAllCouponPayload,
} from './interfaces'

/** 정기구독 신청건 > 매 결제시 쿠폰 사용 여부 조회 */
export const fetchUseAllCoupon = createAsyncThunk<FetchUseAllCouponPayload, FetchUseAllCouponParams, ThunkApi<string>>(
    'management/coupon/fetchUseAllCoupon',
    async ({pageSet}, {rejectWithValue, getState, dispatch}) => {
        const state = getState()
        const {seqID} = commonSelector(state)

        try {
            const {responseData} = await api.fetchUseAllCoupon({pageSet, subscriptionId: seqID})

            return responseData
        } catch {
            dispatch(
                systemAlert({message: '해당 화면에 접근할 수 없습니다. 확인 후 다시 시도해주세요.', type: 'ALERT'}),
            )
            dispatch(changeLocation({type: 'BACK'}))

            return rejectWithValue(RejectValue.FETCH_USE_ALL_COUPON_REJECTED_DEFAULT)
        }
    },
)

/** 정기구독 신청건 > 매 결제시 쿠폰 사용 설정 변경 */
export const changeUseAllCoupon = createAsyncThunk<
    ChangeUseAllCouponPayload,
    ChangeUseAllCouponParams,
    ThunkApi<string>
>('management/coupon/changeUseAllCoupon', async ({pageSet}, {getState, rejectWithValue, dispatch}) => {
    const state = getState()
    const {seqID} = commonSelector(state)
    const {useAllCoupon} = orderSheetCouponSelector(state)

    try {
        await api.updateUseAllCoupon({pageSet, subscriptionId: seqID, useAllCoupon: !!useAllCoupon})

        dispatch(systemAlert({type: 'ALERT', message: '등록되었습니다.'}))
        dispatch(changeLocation({type: isMobile ? 'BACK' : 'CLOSE'}))
    } catch {
        dispatch(
            systemAlert({
                message: '일시적인 오류로 쿠폰 사용 설정 변경에 실패했습니다. 잠시 후 다시 시도해주세요.',
                type: 'ALERT',
            }),
        )

        return rejectWithValue(RejectValue.CHANGE_USE_ALL_COUPON_REJECTED_DEFAULT)
    }
})
